<template>
  <li @click.stop.prevent="handleClick($event)" v-model="model">
    <a>
      {{ label }}
      <i v-if="isActive" class="fa fa-check pos-abs pos-r-sm tex-small m-t-xs sort-by-check inline"></i>
    </a>
  </li>
</template>

<script>
  export default {
    name: 'filtro-status-item',
    props: {
      disabled: Boolean,
      label: String,
      value: {
        required: true
      },
      val: {},
      toggleClass: {
        type: String,
        default: null
      }
    },
    methods: {
      handleClick (e) {
        if (this.disable) {
          return
        }
        if (this.isArray) {
          if (this.index === -1) {
            this.model.push(this.val)
          } else {
            this.model.splice(this.index, 1)
          }
          this.__onChange()
          return
        }
        this.model = this.val
        this.__onChange()
      },
      __onChange () {
        this.$emit('change', this.model)
      }
    },
    computed: {
      model: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      },
      isArray () {
        return Array.isArray(this.value)
      },
      index () {
        if (this.isArray) {
          return this.model.indexOf(this.val)
        }
      },
      isActive () {
        return this.isArray
          ? this.model.indexOf(this.val) > -1
          : this.model === this.val
      }
    }
  }
</script>

<!--<style lang="stylus"></style>-->



// WEBPACK FOOTER //
// FiltroStatusItem.vue?6cb21854